import { createFileRoute, Link } from "@tanstack/react-router";
import {
  Gavel,
  Building2,
  Users,
  Scale,
  Heart,
  Briefcase,
  TrendingUp,
  ShieldCheck,
  FileWarning,
  ArrowRight,
  Home,
  ScrollText,
  HardHat,
  Landmark,
  FileSignature,
  FileText,
  Coins,
  Banknote,
} from "lucide-react";

export const Route = createFileRoute("/areas")({
  head: () => ({
    meta: [
      { title: "Áreas de Práctica — Estudio Libertad E.A.E.S." },
      {
        name: "description",
        content:
          "Áreas de práctica del Estudio Libertad E.A.E.S.: penal, procesal penal, civil, familia, niñez y adolescencia, comercial, societario, penal patrimonial, inversiones en valores, sucesorio, laboral, inmobiliario, notarial, convocatoria de acreedores y quiebras, juicios ejecutivos, procesos ordinarios, administrativo sancionatorio, contencioso administrativo e indemnizatorio patrimonial.",
      },
      { property: "og:title", content: "Áreas de Práctica — Estudio Libertad E.A.E.S." },
      {
        property: "og:description",
        content:
          "Práctica penal, civil, familia, comercial, societaria, sucesoria, laboral, inmobiliaria, notarial, convocatoria de acreedores y quiebras, juicios ejecutivos, procesos ordinarios, contencioso administrativa e indemnizatoria patrimonial en Asunción, Paraguay.",
      },
    ],
  }),
  component: AreasPage,
});

const RODRIGO = [
  {
    icon: Gavel,
    title: "Derecho Penal General",
    text: "Defensa en delitos contra las personas, contra la propiedad y contra la administración pública. Asistencia desde la instrucción hasta el juicio oral.",
  },
  {
    icon: Building2,
    title: "Derecho Penal Económico",
    text: "Estafas, administración fraudulenta, delitos tributarios y societarios. Defensa corporativa para empresas y directivos.",
  },
  {
    icon: FileWarning,
    title: "Litigación Compleja",
    text: "Estrategia procesal en juicios orales, recursos de apelación y casación ante la Corte Suprema de Justicia del Paraguay.",
  },
  {
    icon: ShieldCheck,
    title: "Asesoría Penal Preventiva",
    text: "Compliance, due diligence y consultoría para minimizar riesgos legales y proteger la responsabilidad penal de directivos y empresas.",
  },
];

const LAURA = [
  {
    icon: Scale,
    title: "Derecho Civil",
    text: "Litigios contractuales, responsabilidad civil, daños y perjuicios, sucesiones y demás procesos civiles contenciosos y voluntarios.",
  },
  {
    icon: Heart,
    title: "Derecho de Familia",
    text: "Divorcios, regímenes patrimoniales, alimentos, régimen de relacionamiento, filiación y conflictos de familia atendidos con sensibilidad técnica.",
  },
  {
    icon: Users,
    title: "Niñez y Adolescencia",
    text: "Tutela, adopción, custodia, patria potestad y procesos vinculados a la protección integral de niños, niñas y adolescentes.",
  },
];

const GERARDO = [
  {
    icon: Building2,
    title: "Derecho Comercial & Societario",
    text: "Constitución y reorganización de sociedades, contratos comerciales, conflictos societarios y asesoramiento corporativo permanente.",
  },
  {
    icon: Gavel,
    title: "Penal Patrimonial",
    text: "Defensa en delitos económicos y patrimoniales: estafas, administración fraudulenta, delitos tributarios y societarios.",
  },
  {
    icon: TrendingUp,
    title: "Inversiones en Valores",
    text: "Asesoramiento jurídico en inversiones en valores, mercado de capitales y estructuración de operaciones financieras.",
  },
  {
    icon: Briefcase,
    title: "Civil Patrimonial",
    text: "Asesoramiento y litigio civil con foco patrimonial para empresas, directivos e inversionistas.",
  },
];

const JOSE = [
  {
    icon: ScrollText,
    title: "Derecho Sucesorio",
    text: "Sucesiones testamentarias e intestadas, partición de bienes, administración de herencia y resolución de conflictos hereditarios.",
  },
  {
    icon: Heart,
    title: "Derecho Civil y Familia",
    text: "Procesos civiles, divorcios, regímenes patrimoniales, alimentos, filiación y demás trámites de protección de la familia.",
  },
  {
    icon: HardHat,
    title: "Derecho Laboral",
    text: "Asesoramiento a trabajadores y empleadores en contratos, liquidaciones, despidos, sumarios y litigios ante el fuero laboral.",
  },
  {
    icon: Home,
    title: "Derecho Inmobiliario",
    text: "Compraventas, transferencias, regularización de inmuebles, contratos de arrendamiento y due diligence registral.",
  },
  {
    icon: FileSignature,
    title: "Asesoría Notarial",
    text: "Acompañamiento en escrituras públicas, poderes, contratos y demás instrumentos que requieren intervención notarial.",
  },
  {
    icon: Banknote,
    title: "Convocatoria de Acreedores y Quiebras",
    text: "Patrocinio en convocatorias de acreedores y procesos de quiebra. Defensa de deudores y acreedores, verificación de créditos y resguardo del patrimonio comprometido.",
  },
];

const JAVIER = [
  {
    icon: Gavel,
    title: "Derecho Penal",
    text: "Defensa técnica en causas penales: delitos contra las personas, contra la propiedad y contra la administración pública.",
  },
  {
    icon: Scale,
    title: "Derecho Procesal Penal",
    text: "Patrocinio durante la investigación, etapa intermedia, juicio oral y recursos, con foco en la garantía del debido proceso.",
  },
  {
    icon: FileText,
    title: "Derecho Administrativo Sancionatorio",
    text: "Defensa frente a sumarios y sanciones impuestas por la Administración Pública en sus distintos órganos y reparticiones.",
  },
  {
    icon: Landmark,
    title: "Derecho Contencioso Administrativo",
    text: "Impugnación judicial de actos administrativos y litigios contra el Estado ante el Tribunal de Cuentas y demás instancias.",
  },
];

const ALEJANDRO = [
  {
    icon: Gavel,
    title: "Derecho Penal",
    text: "Defensa técnica en causas penales: delitos contra las personas, contra la propiedad y contra la administración pública.",
  },
  {
    icon: Scale,
    title: "Derecho Procesal Penal",
    text: "Estrategia procesal en investigación, etapa intermedia, juicio oral y recursos, resguardando el debido proceso del defendido.",
  },
  {
    icon: Briefcase,
    title: "Derecho Civil y Comercial",
    text: "Litigios contractuales, responsabilidad civil, contratos comerciales y resolución de conflictos entre particulares y empresas.",
  },
  {
    icon: Building2,
    title: "Derecho Societario",
    text: "Constitución, reorganización y conflictos societarios. Asesoramiento permanente a sociedades, accionistas y directivos.",
  },
  {
    icon: Coins,
    title: "Indemnizatorio Patrimonial",
    text: "Reclamos de daños y perjuicios, indemnizaciones patrimoniales y recuperación de activos en sede civil y comercial.",
  },
];

const SERGIO = [
  {
    icon: Gavel,
    title: "Derecho Penal",
    text: "Defensa técnica en causas penales: delitos contra las personas, contra la propiedad y contra la administración pública.",
  },
  {
    icon: Scale,
    title: "Derecho Procesal Penal",
    text: "Patrocinio durante la investigación, etapa intermedia, juicio oral y recursos, con foco en la garantía del debido proceso.",
  },
  {
    icon: FileText,
    title: "Juicios Ejecutivos",
    text: "Cobro judicial de títulos de crédito, pagarés, cheques, facturas y demás documentos ejecutivos. Embargos y ejecución de sentencias.",
  },
  {
    icon: ScrollText,
    title: "Procesos Ordinarios",
    text: "Patrocinio en juicios ordinarios civiles y comerciales: cumplimiento de contratos, responsabilidad civil y demás controversias entre particulares y empresas.",
  },
  {
    icon: HardHat,
    title: "Demandas Laborales",
    text: "Asesoramiento y litigio laboral para trabajadores y empleadores: reclamos de rubros laborales, despidos, liquidaciones y conflictos ante el fuero del trabajo.",
  },
];

function AreasPage() {
  return (
    <>
      {/* HERO */}
      <section className="bg-navy-900 py-24 text-stone-100 md:py-32">
        <div className="container-elegant text-center">
          <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-400">
            Áreas de Práctica
          </span>
          <h1 className="mx-auto mt-6 max-w-3xl font-serif text-4xl leading-tight md:text-6xl">
            Una práctica integral conducida por{" "}
            <span className="italic text-gold-400">siete socios</span>.
          </h1>
          <div className="mx-auto mt-8 h-px w-16 bg-gold-500" />
          <p className="mx-auto mt-8 max-w-2xl text-stone-100/70">
            Los siete socios del estudio combinan sus especialidades para ofrecer asesoramiento
            penal, procesal penal, civil, comercial, societario, de familia, sucesorio, laboral,
            inmobiliario, notarial, convocatoria de acreedores y quiebras, juicios ejecutivos,
            procesos ordinarios, contencioso administrativo e indemnizatorio patrimonial bajo un
            mismo equipo.
          </p>
        </div>
      </section>

      {/* RODRIGO MONGES LUCES */}
      <section className="py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Rodrigo Monges Luces · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Derecho Penal — Atención directa
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {RODRIGO.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="group border border-navy-900/10 bg-white p-10 transition-all hover:border-gold-500 hover:shadow-xl hover:shadow-navy-900/5"
              >
                <div className="flex h-12 w-12 items-center justify-center border border-gold-500/40 text-gold-500 transition-colors group-hover:bg-gold-500 group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-8 font-serif text-2xl text-navy-900">{title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-navy-900/65">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* LAURA FIGARI */}
      <section className="bg-stone-100 py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Laura Figari · Socia
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Civil · Familia · Niñez y Adolescencia
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {LAURA.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="flex gap-6 border-l-2 border-gold-500/40 bg-white p-8"
              >
                <Icon className="mt-1 h-6 w-6 shrink-0 text-gold-500" />
                <div>
                  <h3 className="font-serif text-xl text-navy-900">{title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-900/65">{text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* GERARDO BENITEZ */}
      <section className="py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Gerardo Benítez · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Civil · Comercial · Sociedades · Penal Patrimonial · Valores
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {GERARDO.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="group border border-navy-900/10 bg-white p-10 transition-all hover:border-gold-500 hover:shadow-xl hover:shadow-navy-900/5"
              >
                <div className="flex h-12 w-12 items-center justify-center border border-gold-500/40 text-gold-500 transition-colors group-hover:bg-gold-500 group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-8 font-serif text-2xl text-navy-900">{title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-navy-900/65">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* JOSE MERELES */}
      <section className="bg-stone-100 py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. José Mereles · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Sucesorio · Civil · Familia · Laboral · Inmobiliario · Notarial · Quiebras
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {JOSE.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="flex gap-6 border-l-2 border-gold-500/40 bg-white p-8"
              >
                <Icon className="mt-1 h-6 w-6 shrink-0 text-gold-500" />
                <div>
                  <h3 className="font-serif text-xl text-navy-900">{title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-900/65">{text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* JAVIER GODOY MORENO */}
      <section className="py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Francisco Javier Godoy Moreno · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Penal · Procesal Penal · Administrativo Sancionatorio · Contencioso Administrativo
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {JAVIER.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="group border border-navy-900/10 bg-white p-10 transition-all hover:border-gold-500 hover:shadow-xl hover:shadow-navy-900/5"
              >
                <div className="flex h-12 w-12 items-center justify-center border border-gold-500/40 text-gold-500 transition-colors group-hover:bg-gold-500 group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-8 font-serif text-2xl text-navy-900">{title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-navy-900/65">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ALEJANDRO FERNANDEZ */}
      <section className="bg-stone-100 py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Alejandro Daniel Fernández · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Penal · Procesal Penal · Civil y Comercial · Societario · Indemnizatorio Patrimonial
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {ALEJANDRO.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="flex gap-6 border-l-2 border-gold-500/40 bg-white p-8"
              >
                <Icon className="mt-1 h-6 w-6 shrink-0 text-gold-500" />
                <div>
                  <h3 className="font-serif text-xl text-navy-900">{title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-900/65">{text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* SERGIO CAÑETE */}
      <section className="py-24 md:py-32">
        <div className="container-elegant">
          <div className="mb-16 max-w-3xl">
            <span className="text-[10px] font-semibold tracking-[0.4em] uppercase text-gold-500">
              Abg. Sergio Cañete · Socio
            </span>
            <h2 className="mt-3 font-serif text-3xl text-navy-900 md:text-4xl">
              Penal · Procesal Penal · Juicios Ejecutivos · Procesos Ordinarios · Laboral
            </h2>
            <div className="mt-5 h-px w-16 bg-gold-500" />
          </div>

          <div className="grid gap-8 md:grid-cols-2">
            {SERGIO.map(({ icon: Icon, title, text }) => (
              <article
                key={title}
                className="group border border-navy-900/10 bg-white p-10 transition-all hover:border-gold-500 hover:shadow-xl hover:shadow-navy-900/5"
              >
                <div className="flex h-12 w-12 items-center justify-center border border-gold-500/40 text-gold-500 transition-colors group-hover:bg-gold-500 group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-8 font-serif text-2xl text-navy-900">{title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-navy-900/65">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-navy-950 py-24 text-stone-100">
        <div className="container-elegant flex flex-col items-center justify-between gap-8 md:flex-row">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl">
              ¿Su caso encaja en alguna de estas áreas?
            </h2>
            <p className="mt-3 text-stone-100/65">
              Conversemos en una consulta privada y confidencial.
            </p>
          </div>
          <Link
            to="/contacto"
            className="inline-flex shrink-0 items-center gap-3 bg-gold-500 px-8 py-4 text-[11px] font-semibold tracking-[0.2em] uppercase text-white transition-transform hover:scale-[1.02]"
          >
            Agendar Consulta
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
